<template>
  <v-card>
    <v-card-title primary-title>
      <div class="headline blue--text">Item do serviço</div>
    </v-card-title>
    <v-container>
      <v-layout row wrap px-3>
        <v-flex xs12 text-xs-center style="margin-top: -24px;">
          <span class="grey--text" v-html="loadingText"></span>
        </v-flex>
        <v-flex xs12>
          <v-text-field v-model="record_info.description" label="Descrição" />
        </v-flex>
        <v-flex xs4>
          <v-text-field v-model="record_info.quantity" label="Quant" />
        </v-flex>
        <v-flex xs1>
        </v-flex>
        <v-flex xs7>
          <v-text-field v-model="record_info.value" label="Valor" />
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="white" class="grey--text" @click="$router.go(-1)">Cancelar</v-btn>
      <v-btn color="blue darken-2" dark @click="saveRecord()">Adicionar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  name: 'OrderItemForm',
  props: {
    record: Object
  },
  data() {
    return {
      record_info: {},
      loading: false
    }
  },
  computed: {
    loadingText() {
      return this.loading ? 'Carregando...' : '&nbsp;'
    },
    orderId() {
      const route_check_result = pathToRegexp('/cliente/:id/servico/:service_id*').exec(this.$route.path)
      return route_check_result === null ? null : (route_check_result[2] == 'novo' ? null : route_check_result[2]);
    },
    orderItemId() {
      const route_check_result = pathToRegexp('/cliente/:id/servico/:service_id/:item_id').exec(this.$route.path)
      return route_check_result === null ? null : (route_check_result[3] == 'novo' ? null : route_check_result[3]);
    },
    updateState() {
      return this.orderItemId ? (this.orderItemId === 'novo' ? false : true) : false
    },
    serviceItemId() {
      const route_check_result = pathToRegexp('/cliente/:id/servico/:service_id/:service_item_id').exec(this.$route.path)
      return route_check_result === null ? null : (route_check_result[3] == 'novo' ? null : route_check_result[3]);
    }
  },
  methods: {
    saveRecord() {
      let successCallback = (response) => {
        this.$router.go(-1)
      }

      let errorCallback = (response) => {
        debugger
      }

      let payload = {
        order_id: this.orderId,
        quantity: this.record.quantity,
        description: this.record.description,
        value: this.record.value,
        notes: this.record.notes
      }

      if (this.updateState) {
        this.$http.put(`${this.$root.base_url}/orders_items/${this.orderItemId}`, payload, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
      } else {
        // only required on creation
        payload.created_at  = Date.now()

        this.$http.post(`${this.$root.base_url}/orders_items`, payload, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
      }
    },
    loadRecord() {
      this.loading = true

      let successCallback = (response) => {
        if (response.body.data) {
          this.loading = false
          this.record_info = response.body.data[0]
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      this.$http.get(`${this.$root.base_url}/orders_items/${this.serviceItemId}`, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
    }
  },
  mounted() {
    this.record_info = this.record
    if (typeof this.record.id !== 'undefined') {
      this.loading = false
    }
    if ((this.serviceItemId) && (typeof(this.record_info.id) === 'undefined')) {
      this.loadRecord()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mecanica/OrderItemForm.vue